export const NodePaletteItem = ({
  node,
  onDragStart,
}: {
  node: { label: string; icon: React.ReactNode; bgClassName: string };
  onDragStart: (e: React.DragEvent) => void;
}) => {
  return (
    <div
      className="p-1 rounded-md cursor-move hover:bg-bg-primary-hover"
      draggable
      onDragStart={onDragStart}
    >
      <div className="flex items-center gap-2">
        <div className={`${node.bgClassName} rounded-md p-1.5`}>
          {node.icon}
        </div>
        <span className="txt-small-medium">{node.label}</span>
      </div>
    </div>
  );
};
